export const UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_PREFIX = "features.topics.components.upload_data_topic_details_modal";

export const UPLOAD_DATA_TOPIC_DETAILS_MODAL_I18N_KEYS = {
  modal_title:                                "modal_title",
  step_one:                                   "step_one",
  topic_name:                                 "topic_name",
  topic_name_missing_error:                   "topic_name_missing_error",
  topic_name_already_exists_error:            "topic_name_already_exists_error",
  description:                                "description",
  description_instructions:                   "description_instructions",
  categories:                                 "categories",
  categories_instructions:                    "categories_instructions",
  email_when_ready:                           "email_when_ready",
  cancel_button_text:                         "cancel_button_text",
  proceed_button_text:                        "proceed_button_text",
  save_button_text:                           "save_button_text"
};


// WEBPACK FOOTER //
// ./src/features/topics/components/constants/i18n/UploadDataTopicDetailsModali18nConstants.js